import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Tooltip, OverlayTrigger } from 'react-bootstrap';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import { Link } from "react-router-dom";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import axios from 'axios';

const ViewBranch = ({ show, onClose,branchData }) => {

    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };

    const chatScrollRef = useRef(null);
    const branchType = branchData?.manage_branch_type === 0 ? 'Branch' : 'Franchise';
    const [areas, setAreas] = useState([]);
    const [deliveryPoints, setDeliveryPoints] = useState([]);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    
    const getEmbedUrlFromLocationUrl = (url) => {
        if (!url) return null;
        
        try {
            // Example URL: https://www.google.com/maps/@9.9276411,78.1451264,15z?entry=ttu&g_ep=...
            const regex = /@(-?\d+\.\d+),(-?\d+\.\d+)/;
            const match = url.match(regex);
            if (match) {
            const lat = match[1];
            const lng = match[2];
            // Construct embed URL without API key
            return `https://www.google.com/maps?q=${lat},${lng}&hl=en&z=15&output=embed`;
            }
        } catch {
            return null;
        }
        return null;
    };

    const embedUrl = getEmbedUrlFromLocationUrl(branchData.location_url);

    // useEffect(() => {
    //     if (show && branchData?.sno) {
    //         axios.get(`${baseURL}/managearea`, {
    //             params: { branch_name: branchData.sno }
    //         })
    //         .then(response => {
    //             // console.log('Fetched Areas:', response.data);
    //             // Assuming response.data.data contains the areas array
    //             const fetchedAreas = response.data.data.data || [];
    //             setAreas(fetchedAreas.map(a => a.area_name));
    //         })
    //         .catch(error => {
    //             console.error('Failed to fetch areas:', error);
    //             setAreas([]);
    //         });
    //     } else {
    //         setAreas([]);
    //     }
    // }, [show, branchData, baseURL]);

    useEffect(() => {
        if (show && branchData?.sno) {
            axios.get(`${baseURL}/managearea`, {
                params: { branch_id: branchData.sno }
            })
            .then(response => {
                const fetchedAreas = response.data.data.data || [];
                const filtered = fetchedAreas.filter(area => area.branch_name === branchData.sno);
                setAreas(filtered.map(a => a.area_name));
            })
            .catch(error => {
                console.error('Failed to fetch areas:', error);
                setAreas([]);
            });
        } else {
            setAreas([]);
        }
    }, [show, branchData, baseURL]);

    useEffect(() => {
        if (show && branchData?.sno) {
            axios.get(`${baseURL}/managedeliverypoint`, {
                params: { branch_id: branchData.sno }
            })
            .then(response => {
                const fetchedPoints = response.data.data.data || [];
                // Filter delivery points that belong to the current branch
                const filteredPoints = fetchedPoints.filter(dp => dp.branch_name === Number(branchData.sno));
                // console.log(filteredPoints);
                setDeliveryPoints(filteredPoints.map(dp => dp.delivery_point));
            })
            .catch(error => {
                console.error('Failed to fetch delivery points:', error);
                setDeliveryPoints([]);
            });
        } else {
            setDeliveryPoints([]);
        }
    }, [show, branchData, baseURL]);

    useEffect(() => {
        if (chatScrollRef.current) {
            chatScrollRef.current.scrollTop = chatScrollRef.current.scrollHeight;
        }
    }, []);

    return (
        <Modal show={show} size="xl"  >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white text-white">View Branch</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-9">
                            {/* <div className='text-center mb-3'>
                                <div className="bg-danger-light border-bottom text-black font-w600 fs-3">
                                    <label className='mb-0'>Base Info</label>
                                </div>
                            </div> */}
                            <label className='font-w600 fs-4 text-red mb-3'>Base Information</label>
                            <div className="row mb-2">
                                <div className='col-lg-4 col-md-12 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Type</label>
                                    <label className='text-black fs-6 font-w500'>{branchType}</label>
                                </div>
                                <div className='col-lg-4 col-md-12 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Branch Name</label>
                                    <label className='text-black fs-6 font-w500'>{branchData.branch_name}</label>
                                </div>
                                {/* <div className='col-lg-4 col-md-12 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Business Name</label>
                                    <label className='text-black fs-6 font-w500'>APF Foods</label>
                                </div> */}
                                <div className='col-lg-4 col-md-12 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Business Email ID</label>
                                    <label className='text-black fs-6 font-w500'>{branchData.business_email_id}</label>
                                </div>
                                <div className='col-lg-4 col-md-12 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Business Mobile No</label>
                                    <label className='text-black fs-6 font-w500'>{branchData.business_mobile_no}</label>
                                </div>
                                <div className='col-lg-4 col-md-12 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Location URL</label>
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span>{branchData.location_url}</span></Tooltip>} >
                                        <Link to={branchData.location_url} target='_blank'>
                                            <div className='text-truncate text-black fs-6 font-w500 mw-300px'>{branchData.location_url}</div></Link>
                                    </OverlayTrigger>
                                </div>
                                <div className='col-lg-4 col-md-12 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Website URL</label>
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span>{branchData.website_url}</span></Tooltip>} >
                                        <Link to={branchData.website_url} target='_blank'>
                                            <div className='text-truncate mw-300px text-black fs-6 font-w500'>{branchData.website_url}</div></Link>
                                    </OverlayTrigger>
                                </div>
                                <div className='col-lg-4 col-md-12 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Opening Date</label>
                                    <label className='text-black fs-6 font-w500'>{branchData.opening_date}</label>
                                </div>
                                <div className='col-lg-4 col-md-12 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>City Short Code</label>
                                    <label className='text-black fs-6 font-w500'>{branchData.city_short_code}</label>
                                </div>
                                <div className='col-lg-4 col-md-12 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>CIN Number</label>
                                    <label className='text-black fs-6 font-w500'>{branchData.cin_no}</label>
                                </div>
                                <div className='col-lg-4 col-md-12 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>PAN Number</label>
                                    <label className='text-black fs-6 font-w500'>{branchData.pan_no}</label>
                                </div>
                                <div className='col-lg-4 col-md-12 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>GST Number</label>
                                    <label className='text-black fs-6 font-w500'>{branchData.gst_no}</label>
                                </div>
                                <div className='col-lg-4 col-md-12 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Time Zone</label>
                                    <label className='text-black fs-6 font-w500'>{branchData.time_zone_data.time_zone}({branchData.time_zone_data.utc_offset})</label>
                                </div>
                                <div className='col-lg-4 col-md-12 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Currency Format</label>
                                    <label className='text-black fs-6 font-w500'>{branchData.currency_format_data.currency_code}</label>
                                </div>
                                <div className='col-lg-8 col-md-12 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Address</label>
                                    <label className='text-black fs-6 font-w500'>{branchData.door}, {branchData.area}, {branchData.city_data.name} - {branchData.pincode}, {branchData.state_data.name}, {branchData.country_data.name}.</label>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3'>
                            {/* <div className='text-center mb-3'>
                                <div className="bg-danger-light border-bottom text-black font-w600 fs-3">
                                    <label className='mb-0'>Account Details</label>
                                </div>
                            </div> */}
                            <label className='font-w600 fs-4 text-red mb-3'>Account Information</label>
                            <div className="row mb-2">
                                <div className='col-lg-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Bank Name</label>
                                    <label className='text-black fs-6 font-w500'>{branchData.bank_name}</label>
                                </div>
                                <div className='col-lg-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Bank Branch</label>
                                    <label className='text-black fs-6 font-w500'>{branchData.bank_branch}</label>
                                </div>
                                <div className='col-lg-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Account Holder</label>
                                    <label className='text-black fs-6 font-w500'>{branchData.account_holder}</label>
                                </div>
                                <div className='col-lg-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Account No</label>
                                    <label className='text-black fs-6 font-w500'>{branchData.account_no}</label>
                                </div>
                                <div className='col-lg-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>IFSC Code</label>
                                    <label className='text-black fs-6 font-w500'>{branchData.ifsc_code}</label>
                                </div>
                            </div>

                        </div>
                        <div className='row mt-3'>
                            <div className='col-lg-3'>
                                <label className='font-w600 fs-4 text-red mb-3'>Incharge Details</label>
                                {/* <div className='text-center mb-3'>
                                    <div className="bg-danger-light border-bottom text-black font-w600 fs-3">
                                        <label className='mb-0'>Incharge Details</label>
                                    </div>
                                </div> */}
                                <div className="row mb-2">
                                    {branchData.assign_manager?.length > 0 ? (
                                        <>
                                    <div className='col-lg-12 d-flex flex-column mb-3'>
                                        <label className='text-gray-800 font-w500 fs-7'>Person</label>
                                        <label className='text-black fs-6 font-w500'>{branchData.assign_manager[0].employee_name}</label>
                                    </div>
                                    <div className='col-lg-12 d-flex flex-column mb-3'>
                                        <label className='text-gray-800 font-w500 fs-7'>Email ID</label>
                                        <label className='text-black fs-6 font-w500'>{branchData.assign_manager[0].mail_id}</label>
                                    </div>
                                    <div className='col-lg-12 d-flex flex-column mb-3'>
                                        <label className='text-gray-800 font-w500 fs-7'>Mobile No</label>
                                        <label className='text-black fs-6 font-w500'>{branchData.assign_manager[0].phone_no}</label>
                                    </div>
                                    {/* <div className='col-lg-12 d-flex flex-column mb-3'>
                                        <label className='text-gray-800 font-w500 fs-7'>Position</label>
                                        <label className='text-black fs-6 font-w500'>{branchData.assigned_managers[0].job_role?.jobrole_name || 'N/A'}</label>
                                    </div> */}
                                </>
                                ) : (
                                    <div className="col-lg-12 text-muted fs-6">No incharge assigned for this branch.</div>
                                )}
                                </div>
                            </div>
                            <div className='col-lg-3'>
                                {/* <div className='text-center mb-3'>
                                    <div className="bg-danger-light border-bottom text-black font-w600 fs-3">
                                        <label className='mb-0'>
                                            <span>Area</span>
                                        </label>
                                    </div>
                                </div> */}
                                <label className='font-w600 fs-4 text-red mb-3'>Area</label>
                                <div className="row mb-2 px-3 py-2">
                                    <div className='scroll-y min-h-225px mh-250px'>
                                        {areas.length > 0 ? (
                                        areas.map((area, index) => (
                                        <label className="col-12 text-black fs-6 font-w500" key={index}>{area} </label>
                                        ))
                                        ) : (
                                            <label className="col-12 text-muted">No areas found for this branch.</label>
                                        )}
                                        {/* <label className="col-12 text-black fs-6 font-w500">Madurai</label>
                                        <label className="col-12 text-black fs-6 font-w500">Periyar Nagar </label>
                                        <label className="col-12 text-black fs-6 font-w500">Kamarajar Salai </label>
                                        <label className="col-12 text-black fs-6 font-w500">KK Nagar </label>
                                        <label className="col-12 text-black fs-6 font-w500">Theppakulam </label>
                                        <label className="col-12 text-black fs-6 font-w500">Villapuram </label> */}

                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-3'>
                                {/* <div className='text-center mb-3'>
                                    <div className="bg-danger-light border-bottom text-black font-w600 fs-3">
                                        <label className='mb-0'>
                                            <span>Delivery Point</span>
                                        </label>
                                    </div>
                                </div> */}
                                <label className='font-w600 fs-4 text-red mb-3'>Delivery Point</label>
                                <div className="row mb-2 px-3 py-2">
                                    <div className='scroll-y min-h-225px mh-250px'>
                                        {deliveryPoints.length > 0 ? (
                                            deliveryPoints.map((point, index) => (
                                                <label className="col-12 text-black fs-6 font-w500">{point} </label>
                                            ))
                                        ) : (
                                            <label className="col-12 text-muted">No delivery points found for this branch.</label>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-3'>
                                <div className='mt-3'>
                                    <div className="d-flex border rounded h-250px w-230px p-2" >
                                        {/* {console.log("Map URL:", branchData.location_url)} */}
                                        {/* {branchData.location_url?.includes("https://www.google.com/maps/embed") ? (
                                        <iframe className='h-245px w-225px' src={branchData.location_url} />
                                        ) : (
                                        <div className='text-muted fs-6'>Map not available for this branch.</div>
                                        )} */}
                                        {/* {branchData.location_url?.includes("maps/embed") ? (
                                        <iframe
                                            className='h-245px w-225px'
                                            src={branchData.location_url}
                                            title="Branch Location Map"
                                            allowFullScreen
                                            loading="lazy"
                                        />
                                        ) : branchData.location_url ? (
                                        <a
                                            className='text-primary fs-6'
                                            href={branchData.location_url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Open Location in Google Maps
                                        </a>
                                        ) : (
                                        <div className='text-muted fs-6'>Map not available for this branch.</div>
                                        )} */}


                                        {branchData.location_url?.includes("maps/embed") ? (
                                            <iframe
                                                className='h-245px w-225px'
                                                src={branchData.location_url}
                                                title="Branch Location Map"
                                                allowFullScreen
                                                loading="lazy"
                                            />
                                            ) : embedUrl ? (
                                            <iframe
                                                className='h-245px w-225px'
                                                src={embedUrl}
                                                title="Branch Location Map"
                                                allowFullScreen
                                                loading="lazy"
                                            />
                                            ) : branchData.location_url ? (
                                            <a
                                                className='text-primary fs-6'
                                                href={branchData.location_url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Open Location in Google Maps
                                            </a>
                                            ) : (
                                            <div className='text-muted fs-6'>Map not available for this branch.</div>
                                        )}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal >
    );
};

export default ViewBranch;

